import _ from "underscore";

!function(t, e) {
    function n(t, e, n) {
        var r = t.children(), o = !1;
        t.empty();
        for (var i = 0, d = r.length; d > i; i++) {
            var l = r.eq(i);
            if (t.append(l), n && t.append(n), a(t, e)) {
                l.remove(), o = !0;
                break;
            }
            n && n.detach();
        }
        return o;
    }
    function r(e, n, i, d, l) {
        var s = !1, c = "table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style", u = "script, .dotdotdot-keep";
        return e.contents().detach().each(function() {
            var f = this, h = t(f);
            if ("undefined" == typeof f || 3 == f.nodeType && 0 == t.trim(f.data).length) return !0;
            if (h.is(u)) e.append(h); else {
                if (s) return !0;
                e.append(h), l && e[e.is(c) ? "after" : "append"](l), a(i, d) && (s = 3 == f.nodeType ? o(h, n, i, d, l) : r(h, n, i, d, l),
                s || (h.detach(), s = !0)), s || l && l.detach();
            }
        }), s;
    }
    function o(e, n, r, o, d) {
        var c = e[0];
        if (!c) return !1;
        var f = s(c), h = -1 !== f.indexOf(" ") ? " " : "　", p = "letter" == o.wrap ? "" : h, g = f.split(p), v = -1, w = -1, b = 0, y = g.length - 1;
        for (o.fallbackToLetter && 0 == b && 0 == y && (p = "", g = f.split(p), y = g.length - 1); y >= b && (0 != b || 0 != y); ) {
            var m = Math.floor((b + y) / 2);
            if (m == w) break;
            w = m, l(c, g.slice(0, w + 1).join(p) + o.ellipsis), a(r, o) ? (y = w, o.fallbackToLetter && 0 == b && 0 == y && (p = "",
            g = g[0].split(p), v = -1, w = -1, b = 0, y = g.length - 1)) : (v = w, b = w);
        }
        if (-1 == v || 1 == g.length && 0 == g[0].length) {
            var x = e.parent();
            e.detach();
            var T = d && d.closest(x).length ? d.length : 0;
            x.contents().length > T ? c = u(x.contents().eq(-1 - T), n) : (c = u(x, n, !0),
            T || x.detach()), c && (f = i(s(c), o), l(c, f), T && d && t(c).parent().append(d));
        } else f = i(g.slice(0, v + 1).join(p), o), l(c, f);
        return !0;
    }
    function a(t, e) {
        return t.innerHeight() > e.maxHeight;
    }
    function i(e, n) {
        for (;t.inArray(e.slice(-1), n.lastCharacter.remove) > -1; ) e = e.slice(0, -1);
        return t.inArray(e.slice(-1), n.lastCharacter.noEllipsis) < 0 && (e += n.ellipsis),
        e;
    }
    function d(t) {
        return {
            width: t.innerWidth(),
            height: t.innerHeight()
        };
    }
    function l(t, e) {
        t.innerText ? t.innerText = e : t.nodeValue ? t.nodeValue = e : t.textContent && (t.textContent = e);
    }
    function s(t) {
        return t.innerText ? t.innerText : t.nodeValue ? t.nodeValue : t.textContent ? t.textContent : "";
    }
    function c(t) {
        do t = t.previousSibling; while (t && 1 !== t.nodeType && 3 !== t.nodeType);
        return t;
    }
    function u(e, n, r) {
        var o, a = e && e[0];
        if (a) {
            if (!r) {
                if (3 === a.nodeType) return a;
                if (t.trim(e.text())) return u(e.contents().last(), n);
            }
            for (o = c(a); !o; ) {
                if (e = e.parent(), e.is(n) || !e.length) return !1;
                o = c(e[0]);
            }
            if (o) return u(t(o), n);
        }
        return !1;
    }
    function f(e, n) {
        return e ? "string" == typeof e ? (e = t(e, n), e.length ? e : !1) : e.jquery ? e : !1 : !1;
    }
    function h(t) {
        for (var e = t.innerHeight(), n = [ "paddingTop", "paddingBottom" ], r = 0, o = n.length; o > r; r++) {
            var a = parseInt(t.css(n[r]), 10);
            isNaN(a) && (a = 0), e -= a;
        }
        return e;
    }
    if (!t.fn.dotdotdot) {
        t.fn.dotdotdot = function(e) {
            if (0 == this.length) return t.fn.dotdotdot.debug('No element found for "' + this.selector + '".'),
            this;
            if (this.length > 1) return this.each(function() {
                t(this).dotdotdot(e);
            });
            var o = this;
            o.data("dotdotdot") && o.trigger("destroy.dot"), o.data("dotdotdot-style", o.attr("style") || ""),
            o.css("word-wrap", "break-word"), "nowrap" === o.css("white-space") && o.css("white-space", "normal"),
            o.bind_events = function() {
                return o.bind("update.dot", function(e, d) {
                    e.preventDefault(), e.stopPropagation(), l.maxHeight = "number" == typeof l.height ? l.height : h(o),
                    l.maxHeight += l.tolerance, "undefined" != typeof d && (("string" == typeof d || d instanceof HTMLElement) && (d = t("<div />").append(d).contents()),
                    d instanceof t && (i = d)), g = o.wrapInner('<div class="dotdotdot" />').children(),
                    g.contents().detach().end().append(i.clone(!0)).find("br").replaceWith("  <br />  ").end().css({
                        height: "auto",
                        width: "auto",
                        border: "none",
                        padding: 0,
                        margin: 0
                    });
                    var c = !1, u = !1;
                    return s.afterElement && (c = s.afterElement.clone(!0), c.show(), s.afterElement.detach()),
                    a(g, l) && (u = "children" == l.wrap ? n(g, l, c) : r(g, o, g, l, c)), g.replaceWith(g.contents()),
                    g = null, t.isFunction(l.callback) && l.callback.call(o[0], u, i), s.isTruncated = u,
                    u;
                }).bind("isTruncated.dot", function(t, e) {
                    return t.preventDefault(), t.stopPropagation(), "function" == typeof e && e.call(o[0], s.isTruncated),
                    s.isTruncated;
                }).bind("originalContent.dot", function(t, e) {
                    return t.preventDefault(), t.stopPropagation(), "function" == typeof e && e.call(o[0], i),
                    i;
                }).bind("destroy.dot", function(t) {
                    t.preventDefault(), t.stopPropagation(), o.unwatch().unbind_events().contents().detach().end().append(i).attr("style", o.data("dotdotdot-style") || "").data("dotdotdot", !1);
                }), o;
            }, o.unbind_events = function() {
                return o.unbind(".dot"), o;
            }, o.watch = function() {
                if (o.unwatch(), "window" == l.watch) {
                    var e = t(window), n = e.width(), r = e.height();
                    e.bind("resize.dot" + s.dotId, function() {
                        n == e.width() && r == e.height() && l.windowResizeFix || (n = e.width(), r = e.height(),
                        u && clearInterval(u), u = setTimeout(function() {
                            o.trigger("update.dot");
                        }, 100));
                    });
                } else c = d(o), u = setInterval(function() {
                    if (o.is(":visible")) {
                        var t = d(o);
                        (c.width != t.width || c.height != t.height) && (o.trigger("update.dot"), c = t);
                    }
                }, 500);
                return o;
            }, o.unwatch = function() {
                return t(window).unbind("resize.dot" + s.dotId), u && clearInterval(u), o;
            };
            var i = o.contents(), l = t.extend(!0, {}, t.fn.dotdotdot.defaults, e), s = {}, c = {}, u = null, g = null;
            return l.lastCharacter.remove instanceof Array || (l.lastCharacter.remove = t.fn.dotdotdot.defaultArrays.lastCharacter.remove),
            l.lastCharacter.noEllipsis instanceof Array || (l.lastCharacter.noEllipsis = t.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis),
            s.afterElement = f(l.after, o), s.isTruncated = !1, s.dotId = p++, o.data("dotdotdot", !0).bind_events().trigger("update.dot"),
            l.watch && o.watch(), o;
        }, t.fn.dotdotdot.defaults = {
            ellipsis: "... ",
            wrap: "word",
            fallbackToLetter: !0,
            lastCharacter: {},
            tolerance: 0,
            callback: null,
            after: null,
            height: null,
            watch: !1,
            windowResizeFix: !0
        }, t.fn.dotdotdot.defaultArrays = {
            lastCharacter: {
                remove: [ " ", "　", ",", ";", ".", "!", "?" ],
                noEllipsis: []
            }
        }, t.fn.dotdotdot.debug = function() {};
        var p = 1, g = t.fn.html;
        t.fn.html = function(n) {
            return n != e && !t.isFunction(n) && this.data("dotdotdot") ? this.trigger("update", [ n ]) : g.apply(this, arguments);
        };
        var v = t.fn.text;
        t.fn.text = function(n) {
            return n != e && !t.isFunction(n) && this.data("dotdotdot") ? (n = t("<div />").text(n).html(),
            this.trigger("update", [ n ])) : v.apply(this, arguments);
        };
    }
}(jQuery), $.fn.equalize = function() {
    function setHeight() {
        $this.find(".row").each(function() {
            var $this = $(this), $columns = $this.find('> [class*="col-"]');
            maxHeight = 0, $columns.each(function() {
                var height = $(this).outerHeight();
                maxHeight = height > maxHeight ? height : maxHeight;
            }), $columns.height(maxHeight);
        });
    }
    var $this = $(this);
    setHeight(), $(window).resize(_.throttle(setHeight, 500));
}, $("[equalize]").equalize();

var app = app || {};

app.namespace = function(ns_string) {
    var i, ns_array = ns_string.split("."), parent = app;
    for ("app" === ns_array[0] && (ns_array = ns_array.slice(1)), i = 0; i < ns_array.length; i += 1) "undefined" == typeof parent[ns_array[i]] && (parent[ns_array[i]] = {}),
    parent = parent[ns_array[i]];
    return parent;
}, app.namespace("accountStatus"), app.accountStatus = function($) {
    function init() {
        $("#AccountPopoverLink").popover({
            html: !0,
            content: $("#AccountPopoverContent").html(),
            placement: "bottom"
        });
    }
    return {
        init: init
    };
}(jQuery), app.namespace("contribute"), app.contribute = function($) {
    function init() {
        $("#ContributePopoverLink").popover({
            html: !0,
            content: $("#ContributePopoverContent").html(),
            placement: "bottom"
        });
    }
    return {
        init: init
    };
}(jQuery), app.namespace("dynamicHorizontalNav"), app.dynamicHorizontalNav = function($, w) {
    function showLinksThatFit() {
        var parentWidth = $el.find(".container").width(), combinedWidthOfLinks = 0;
        $el.find(".list-links > li").each(function() {
            var $this = $(this);
            combinedWidthOfLinks += $this.outerWidth(!0), parentWidth > combinedWidthOfLinks ? $this.removeClass("hide") : $this.addClass("hide");
        });
    }
    function init() {
        showLinksThatFit(), $(w).on("resize", _.throttle(showLinksThatFit, 500));
    }
    var parentWidth, $el = $(".dynamic-horizontal-navigation");
    return {
        init: init
    };
}(jQuery, this), app.namespace("forumarticlefilter"), app.forumarticlefilter = function($) {
    var timeout, $el = $(".forum-article-navigation-items > ul > ul"), $parent = $el.closest(".forum-navigation"), $menus = $el.next().addClass("hide"), hideSubMenu = function() {
        $menus.addClass("hide");
    }, toggleSubMenu = function(e) {
        function cleanup($el, eventType) {
            $el.off(eventType), clearTimeout(timeout);
        }
        var $this = $(this), $target = $this.next();
        return e.preventDefault(), clearTimeout(timeout), $target.is(":visible") ? (cleanup($target, "mouseenter"),
        cleanup($target, "mouseleave"), cleanup($this, "mouseleave"), void hideSubMenu()) : void 0;
    }, _init = function() {
        var $click = Modernizr.touch ? "touchstart "+$parent.data("event") : $parent.data("event");
        $el.on($click, toggleSubMenu), $("input[type='checkbox']").change(function() {
            this.checked ? ($(this).parents("li").next("ul").show(), console.log("show")) : ($(this).parents("li").next("ul").hide(),
            console.log("hide"));
        });
    }, _initialHide = function() {
        $el.find("ul").hide(), $el.nextAll("ul").addClass("hide"), $el.hide();
    }, init = function() {
        $el.length && (_init(), _initialHide());
    };
    return {
        init: init
    };
}(jQuery), app.namespace("forummenu"), app.forummenu = function($) {
    var timeout, $el = $(".forum-navigation-items li.active > a"), $parent = $el.closest(".forum-navigation"), $menus = $el.next().addClass("hide"), hideSubMenu = function() {
        $menus.addClass("hide");
    }, toggleSubMenu = function(e) {
        function cleanup($el, eventType) {
            $el.off(eventType), clearTimeout(timeout);
        }
        var $this = $(this), $target = $this.next();
        return e.preventDefault(), clearTimeout(timeout), $target.is(":visible") ? (cleanup($target, "mouseenter"),
        cleanup($target, "mouseleave"), cleanup($this, "mouseleave"), void hideSubMenu()) : ($target.removeClass("hide"),
        $this.on("mouseleave", function(e) {
            cleanup($this, e.type), timeout = setTimeout(hideSubMenu, Modernizr.touch ? 10 : $parent.data("delay"));
        }), void $target.on("mouseenter mouseleave", function(e) {
            cleanup($target, e.type), "mouseleave" === e.type && hideSubMenu();
        }));
    }, _init = function() {
        var $click = Modernizr.touch ? "touchstart "+$parent.data("event"): $parent.data("event");
        $el.on($click, toggleSubMenu), $menuLinks = $(".forum-navigation-content a"), $menuLinks.on($click, function(e) {
            var height = 0;
            $(this).next("ul").length && e.preventDefault(), $menuLinks.closest("li").removeClass("active"),
            $(this).parents("li").addClass("active"), $(".forum-navigation-items ul:visible").each(function() {
                height = height < $(this).height() ? $(this).height() : height;
            }), $(".forum-navigation-content").height(height);
        });
    }, init = function() {
        $el.length && _init();
    };
    return {
        init: init
    };
}(jQuery), app.namespace("menu"), app.menu = function($) {
    var timeout, $el = $(".main-navigation-items li.active > a"), $parent = $el.closest(".main-navigation"), $cloak = $(".main-navigation-cloak"), $menus = $el.next().addClass("hide"), hideSubMenu = function() {
        $menus.addClass("hide"), $cloak.addClass("hide");
    }, toggleSubMenu = function(e) {
        function cleanup($el, eventType) {
            $el.off(eventType), clearTimeout(timeout);
        }
        var $this = $(this), $target = $this.next();
        return e.preventDefault(), clearTimeout(timeout), $target.is(":visible") ? (cleanup($target, "mouseenter"),
        cleanup($target, "mouseleave"), cleanup($this, "mouseleave"), void hideSubMenu()) : ($target.removeClass("hide"),
        $cloak.removeClass("hide").height($(window).height()), $this.on("mouseleave", function(e) {
            cleanup($this, e.type), timeout = setTimeout(hideSubMenu, Modernizr.touch ? 10 : $parent.data("delay"));
        }), void $target.on("mouseenter mouseleave", function(e) {
            cleanup($target, e.type), "mouseleave" === e.type && hideSubMenu();
        }));
    }, _init = function() {
        var $click = Modernizr.touch ? "touchstart "+$parent.data("event"): $parent.data("event");
        $el.on($click, toggleSubMenu), $menuLinks = $(".main-navigation-content a"), $menuLinks.on($click, function(e) {
            var height = 0;
            $(this).next("ul").length && e.preventDefault(), $menuLinks.closest("li").removeClass("active"),
            $(this).parents("li").find("li").removeClass("active"), $(this).parents("li").addClass("active"),
            $(".main-navigation-items ul:visible").each(function() {
                height = height < $(this).height() ? $(this).height() : height;
            }), $(".main-navigation-content").height(height);
        });
    }, init = function() {
        $el.length && _init();
    };
    return {
        init: init
    };
}(jQuery), app.namespace("truncate"), app.truncate = function($) {
    function init() {
        $(".truncate").dotdotdot();
    }
    return {
        init: init
    };
}(jQuery), app.namespace("multiforms"), app.multiforms = function($) {
    function init() {
        $("button.multiform-edit").each(function(index, element) {
            form = $('#'+($(this).attr("data-formid")));
            disableForm(form);
        });
        $(document).on("submit", "form.multiform", function(event) {
            form = event.target;

            performSave = (buttonState(form) == "Save");
            if (performSave) {
//                alert('save');
            } else {
//                alert('edit');
                enableForm(form);
                buttonToSave(form);
                event.preventDefault();
                return false;
            }

            if (buttonAllowAjaxCall(form)) {
                event.preventDefault();
                if (performSave) {
                    submitForm($(form));
                }
            } else {
//                alert ('normal');
                return true;
            }
            return false;
        });
        bindOnload();

        function bindOnload() {
            $("iframe#avatariframe").load(function(){
                $data = $(this).contents().text();
                form = $("#changeavatarform");
                if ($data) {
                    response = $.parseJSON($data);
                    if (response.status === "success") {
                        // Form validated display updated data
                        $buttonData = $("div.form-group:first", form).html();
                        form.html($('form', response.output).html());
                        $("div.form-group:first", form).html($buttonData);
                        disableForm(form);
                        buttonToEdit();
                        bindOnload();
                    } else {
                        // Form not validated display form pannel with errors
                        $buttonData = $("div.form-group:first", form).html();
                        form.html($('form', response.output).html());
                        $("div.form-group:first", form).html($buttonData);
                        bindOnload();
                    }
                }
            });
        }
        function buttonState(form) {
            if ($('.multiform-edit:submit', form).html() === $('.multiform-edit:submit', form).attr('data-save')) {
                return "Save";
            } else {
                return "Edit";
            }
        }
        function buttonAllowAjaxCall(form) {
           return !$('.multiform-edit:submit', form).hasClass('non-ajax');
        }
        function buttonToSave(form) {
           return $('.multiform-edit:submit', form).html($('.multiform-edit:submit', form).attr('data-save'));
        }
        function buttonToEdit(form) {
           return $('.multiform-edit:submit', form).html($('.multiform-edit:submit', form).attr('data-edit'));
        }
        function disableForm(form) {
            $("input,select,textarea", form).each(function() {
                $(this).prop( "disabled", true);
            });
        }
        function enableForm(form) {
            $("input,select,textarea", form).each(function() {
                $(this).prop( "disabled", false);
            });
        }
        function submitForm(form) {
            console.log(form);
            $.ajax({
                url: form.attr('action'),
                type: "POST",
                dataType: "json",
                data: form.serialize()+"&submit="+($(".multiform-edit", form).val()),
                success: function (response) {
                    if (response.status === "success") {
                        // Form validated display updated date
                        $buttonData = $("div.form-group:first", form).html();
                        form.html($('form', response.output).html());
                        $("div.form-group:first", form).html($buttonData);
                        disableForm(form);
                        buttonToEdit();
                    } else {
                        // Form not validated display form pannel with errors
                        $buttonData = $("div.form-group:first", form).html();
                        form.html($('form', response.output).html());
                        $("div.form-group:first", form).html($buttonData);
                    }
                },
                error: function (response) {
                    alert('ajax call error');
//                     handlePageError();
                }
            });
        }
    }
    return {
        init: init
    };
}(jQuery), app.namespace("slugtext"), app.slugtext = function($) {
    function init() {
        $("form input#slug[readonly]").each(function(index, element) {
            slug = $(this);
            $("input#title", $(this).parent().parent().parent()).on("change", function(event) {
                slug.val(slugText($(this).val()));
            });
        });
        function slugText(str) {
            return str.replace(/\W+/g, "-").toLowerCase();
        }
    }
    return {
        init: init
    };
}(jQuery), app.menu.init(), app.forummenu.init(), app.contribute.init(), app.accountStatus.init(),
app.dynamicHorizontalNav.init(), app.truncate.init(), app.forumarticlefilter.init(),
app.multiforms.init(), app.slugtext.init();



// WEBPACK FOOTER //
// ./src/js/legacy/js/main.min.js